import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.err(error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.render ? this.props.render() : null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/commons/components/ErrorBoundary.jsx